<template>
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <circle cx="16" cy="16" r="16" :fill="circleColor" stroke="none"/>
    <path d="M16 28C9.37259 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4" :stroke="secundaryColor" stroke-width="1.2" stroke-linecap="round" stroke-dasharray="2.5 2.5"/>
    <path d="M16 4C22.6274 4 28 9.37258 28 16C28 22.6274 22.6274 28 16 28" :stroke="circleLineColor" stroke-width="1.2" stroke-linecap="round"/>
    <path d="M21.3337 21V19.6667C21.3337 18.9594 21.0527 18.2811 20.5526 17.781C20.0525 17.281 19.3742 17 18.667 17H13.3337C12.6264 17 11.9481 17.281 11.448 17.781C10.9479 18.2811 10.667 18.9594 10.667 19.6667V21" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15.9997 14.3333C17.4724 14.3333 18.6663 13.1394 18.6663 11.6667C18.6663 10.1939 17.4724 9 15.9997 9C14.5269 9 13.333 10.1939 13.333 11.6667C13.333 13.1394 14.5269 14.3333 15.9997 14.3333Z" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: '#3D5DFC',
            required: false
        },
        secundaryColor: {
            type: String,
            default: '#CAD3FF',
            required: false
        },
        circleColor: {
            type: String,
            default: '#E7EBFF',
            required: false
        },
        circleLineColor: {
            type: String,
            default: '#6D85FD',
            required: false
        }

    }
}
</script>